import { useEffect } from 'react';

export const useGaViewItemList = ({
  categoryProducts,
  categoryName,
  categoryUid,
  categoryLoading,
}: {
  categoryProducts: any[];
  categoryName: string;
  categoryUid: string;
  categoryLoading: boolean;
}) => {
  useEffect(() => {
    console.log('useGaViewItemList triggered, loading:', categoryLoading, 'data:', !!categoryProducts);
    if (categoryLoading || !categoryProducts || categoryProducts.length === 0) {
      return;
    }

    try {
      const productItems =
        categoryProducts?.map((temp: any) => {
          return {
            item_name: temp.name,
            item_id: temp.sku,
            quantity: 1,
            item_category: categoryName,
          };
        }) || [];

      const productItemsForPintrk =
        categoryProducts?.map((temp: any) => {
          return {
            product_name: temp.name,
            product_id: temp.uid,
            product_category: categoryName,
            product_price: temp.price_range?.maximum_price?.final_price?.value,
            product_brand: 'awbridal',
          };
        }) || [];

      // 清除之前的ecommerce对象
      window.dataLayer &&
        window.dataLayer.push({
          ecommerce: null,
        });
      // 推送新的事件
      const payload = {
        event: 'view_item_list',
        ecommerce: {
          item_list_id: categoryName,
          item_list_name: categoryName,
          items: productItems,
        },
      };
      console.log('====== view_item_list event payload ======', payload);
      window.dataLayer && window.dataLayer.push(payload);

      window.pintrk &&
        window.pintrk('track', 'viewcategory', {
          line_items: productItemsForPintrk,
        });

      try {
        fetch('/api/pinterest-view-category', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            eventName: 'view_category',
            product: {
              items: productItems,
              category: { uid: categoryUid, name: categoryName },
            },
          }),
        });
      } catch (err) {
        console.error('Pinterest conversion error:', err);
      }
    } catch (err) {
      console.error(err);
    }
  }, [categoryProducts, categoryName, categoryUid, categoryLoading]);

  // 这个hook不需要返回任何内容
};
